import React from 'react';
import Table from 'react-bootstrap/Table';
import {Col, Row} from 'react-bootstrap';

export default class InfoEquipoAdm extends React.Component {

    componentDidMount() {
    }

    render() {
        const {equipo} = this.props;
        const {sensores, usuarios} = equipo;
        return (
            <div>
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        Topic: {equipo.topic}
                        <br/>
                    </Col>
                    {/* <Col xs={12}>
                        <h5>Usuarios asociados</h5>
                        <Table striped bordered hover responsive>
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Usuario</th>
                            </tr>
                            </thead>
                            <tbody>
                            {usuarios !== undefined && usuarios !== null && usuarios.map((item, index) =>
                                <tr key={index}>
                                    <td>{item.id}</td>
                                    <td>{item.username}</td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </Col> */}
                    <Col xs={12}>
                        <h5>Lista de sensores</h5>
                        <Table striped bordered hover responsive>
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Label</th>
                                <th>Nexo</th>
                            </tr>
                            </thead>
                            <tbody>
                            {sensores !== undefined && sensores.map((item, index) =>
                                <tr key={index}>
                                    <td>{item.id}</td>
                                    <td>{item.labelUsuario}</td>
                                    <td>{item.nombreNexo}</td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        );
    }
}